export default "__VITE_ASSET__CSIecY1y__"